import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import SvgIcon from '@/modules/base/components/svg-icon/svg-icon'

const useStyles = makeStyles((theme) => ({
  icon: {
    '&:hover': {
      fill: theme.primary,
      color: theme.primary,
      '& path': {
        fill: theme.primary,
      },
    },
  },
}))

const ICON_SIZE = 20

const ContextMenuCell = (props) => {
  const { actions = [], simulateContextMenuOnClick } = props
  const classes = useStyles()

  const onClick = (e) => {
    if (!simulateContextMenuOnClick) return
    e.preventDefault()
    e.stopPropagation()

    const cellEl = e.currentTarget.closest('.ag-cell')
    if (!cellEl) return

    const rect = e.currentTarget.getBoundingClientRect()
    const evt = new MouseEvent('contextmenu', {
      bubbles: true,
      cancelable: true,
      view: window,
      button: 2,
      buttons: 2,
      clientX: Math.round(rect.left + rect.width / 2),
      clientY: Math.round(rect.top + rect.height / 2),
    })
    cellEl.dispatchEvent(evt)
  }

  const quickActions = useMemo(() => {
    return actions.map((action) => action.icon && <SvgIcon className={classes.icon} svg={action.icon} height={ICON_SIZE} width={ICON_SIZE} onClick={() => action.action?.(props)} />)
  }, [actions])

  return (
    <div
      className='contextMenuCell'
      data-rowindex={props.node.__objectId}
      data-lineindex={props.rowIndex}
    >
      {quickActions}
      <i data-name='contextMenu' className={clsx('icon icon-more_menu contextMenuCellIcon', classes.icon)} onClick={onClick} />
    </div>
  )
}

ContextMenuCell.propTypes = {
  node: PropTypes.object.isRequired,
  rowIndex: PropTypes.number,
  simulateContextMenuOnClick: PropTypes.bool,
  actions: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.elementType.isRequired,
    action: PropTypes.func.isRequired,
  })),
}

export default ContextMenuCell
